/* eslint-disable prettier/prettier */
import { useEffect, useState } from "react";
import { useBindingContext } from "@/apps/@components/binding-context";
import { useNavigate } from "react-router-dom";
import { api, ApiError } from "@/apps/@utils";
import { LoadingOverlay } from "@/apps/@components/loading-overlay";
import { Modal, ModalButton } from "@/apps/@components";
import liff from "@line/liff";

const BindingSalesPage = () => {
	const navigate = useNavigate();
	const { from, payload, clear } = useBindingContext();
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
	const [bindingResult, setBindingResult] = useState("pendding");
  const [isBindingLoading, setIsBindingLoading] = useState(false);

  const [isLineBinding, setIsLineBinding] = useState(false);

  const [bindingSalesperson, setBindingSalesperson] = useState(null);

  const getProfile = async () => {
		try {
			const res = await api.get("/profile");
			return res?.userProfile;
		} catch (error) {
			throw error.response?.data?.error?.code || new Error("Unknown error");
		}
	};

  const checkBindingStatus = async () => {
		try {
			await getProfile();
      return true;
		} catch (errorCode) {
			switch (errorCode) {
				case ApiError.USER_NOT_BINDED:
					return false;
				default:
					break;
			}
		}
	};

	useEffect(() => {
		(async () => {

				if (from === "sales-qrcode") {
          let salesInfo = null;
          setIsBindingLoading(true);

          // 檢查是否已完成 Line 會員綁定
          const isLineBinding = await checkBindingStatus();
          setIsLineBinding(isLineBinding);

          try {
            const salesInfoResult = await api.get("/task-center/salesperson/info", {
              params: {
                salesperson_tb_id: payload.salesperson_tb_id,
              }
            });
            salesInfo = salesInfoResult.data;
          }
          catch (error) {
            setIsBindingLoading(false);
            setTitle("綁定失敗");
            setMessage("品牌服務員不存在");
            setBindingResult("failed");
            clear();
            return;
          }
          try {
            await api.post("/task-center/customer/binding-salesperson", {
              salesperson_tb_id: payload.salesperson_tb_id,
							token: payload.token,
            });

            setIsBindingLoading(false);
            setBindingResult("success");
            setTitle("已完成綁定");
            setMessage(`親愛的貴賓，已為您綁定品牌專屬服務員  ${salesInfo['display_name']}。`);
            setBindingSalesperson(salesInfo);
            clear();
          }
          catch (error) {
            console.error("Error binding customer sales", error);
            const errorCode = error.response.data?.error?.code;
            const salesInfo = error.response.data?.error?.data;
            setBindingSalesperson(salesInfo);
            switch (errorCode) {
              // For the same mobile phone number, cannot send verification code again in 15 seconds
              case ApiError.MEMBER_SALES_BINDING_ALREADY_EXISTS:
                setTitle("已綁定品牌專屬服務員");
                setMessage(`親愛的貴賓，您已綁定品牌專屬服務員 ${salesInfo['display_name']}。`);
                break;
              case ApiError.MEMBER_SALES_BINDING_IS_NOT_EMPTY:
                setTitle("已綁定品牌專屬服務員");
                setMessage(`親愛的貴賓，您已綁定品牌專屬服務員 ${(salesInfo && salesInfo['display_name']) ?? ''}。`);
                break;
              default:
                setTitle(`綁定失敗 ${errorCode}`);
                setMessage("綁定品牌專屬服務員失敗。");
                break;
            }
            setBindingResult("failed");
          } finally {
            setIsBindingLoading(false);
          }
				}
        else {
					navigate("/binding");
				}
		})();
	}, []);


	return (
		<div>
      <LoadingOverlay visible={isBindingLoading} />
			<Modal
				isOpen={isLineBinding && (bindingResult === "success" || bindingResult === "failed")}
        title={title}
        isShowCancelBtn={false}
        footerContent={<ModalButton text="我知道了" onClick={() => liff.closeWindow()} />}
			>
        {message}
      </Modal>
      <Modal
        isOpen={!isLineBinding && (bindingResult === "success" || bindingResult === "failed")}
        title={title}
        isShowCancelBtn={true}
        cancelBtnText="再考慮一下"
        onCancel={() => liff.closeWindow()}
        footerContent={<ModalButton text="確認綁定品牌 Line 會員" onClick={() => window.location.href = "/binding"} />}
      >
        親愛的貴賓，您已綁定品牌專屬服務員 {bindingSalesperson?.display_name}。
        <br />
        現在立即綁定您的品牌專屬 Line 會員帳號，即可獲得優惠券。
      </Modal>
		</div>
	);
};

export default BindingSalesPage;
